// extracted by mini-css-extract-plugin
export default {"container":"F_GLn2br"};